import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./EditCareFunctionality.html";

import EditCareFunctionalityComponentController from "./EditCareFunctionalityComponentController";

export default class EditCareFunctionalityComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditCareFunctionalityComponentController;

        // tslint:disable:max-line-length
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/SelectedEquipment/CameraConfigurations/EditCareFunctionality/EditCareFunctionality.html";

        this.transclude = true;
    }
}

module("mmManagePortal").component("irEditCareFunctionality", new EditCareFunctionalityComponent());
